import { fork, all } from "redux-saga/effects";
import { watchCreateRSVPRequest } from "./workers/create-rsvp-request";
import { watchFetchEvent } from "./workers/fetch-event";
import { watchCreateInvestmentAmount } from "./workers/create-invest-amount-request";
const sagas = [watchCreateRSVPRequest, watchFetchEvent, watchCreateInvestmentAmount];

export default function* root() {
  yield all(sagas.map((saga) => fork(saga)));
}
